import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initGsapStickyCta() {
    const sections = document.querySelectorAll('[data-sticky-cta]');

    sections.forEach((section) => {
        const cards = section.querySelectorAll('.sticky-cta__card');
        const content = section.querySelector('.sticky-cta__content');
        const list = section.querySelector('.sticky-cta__list');

        if (cards.length === 0) return;

        // Validamos que existan ambos elementos para el pin
        if (content && list) {
            let mm = gsap.matchMedia();
            
            // Solo en desktop (lg en bootstrap es 992px)
            mm.add("(min-width: 992px)", () => {
                ScrollTrigger.create({
                    trigger: content,
                    start: "center center", 
                    endTrigger: list,
                    end: "bottom 60%", // Soltamos el pin un poco antes (al 60% de la altura) para evitar que sobresalga
                    pin: true,
                    pinSpacing: false,
                    invalidateOnRefresh: true,
                    markers: false
                });
            });
        }

        cards.forEach((card) => {
            gsap.fromTo(
                card,
                { opacity: 0, y: 30 },
                {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                    ease: "power2.out",
                    scrollTrigger: {
                        trigger: card,
                        start: "top 90%",
                    },
                }
            );
        });
    });
}
